import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { svgProps } from "./defaults";
import { WaveSvg } from "../Wave.styles";
var scalable5 = {
    end: {
        small: /*#__PURE__*/ _jsx(WaveSvg, _object_spread_props(_object_spread({}, svgProps), {
            viewBox: "0 0 375 60",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M0 60V30.329c197.5 9.733 222.5-38.12 375-29.22V60H0Z"
            })
        })),
        large: /*#__PURE__*/ _jsx(WaveSvg, _object_spread_props(_object_spread({}, svgProps), {
            viewBox: "0 0 1440 100",
            children: /*#__PURE__*/ _jsx("path", {
                d: "M0 100V16.126C498 100 908-20.617 1440 3.17V100H0Z"
            })
        }))
    }
};
export { scalable5 };
